import { Dispatch } from 'redux'

import { isOptimizelyFeatureEnabledFactory } from 'containers/OptimizelyRollouts'
import { EXPERIMENT_KEY_SINGLE_MENU_API } from 'routes/Menu/constants'
import { GetState } from 'routes/Menu/fetchData/types'

const hasURLSearchParam = (value: string) => {
  const searchParams = new URLSearchParams(window.location.search)

  return searchParams.get('api') === value
}

export const getSingleMenuApi = async (dispatch: Dispatch<any>, getState: GetState) => {
  if (hasURLSearchParam('single_menu_api')) return true

  const getIsSingleMenuApiEnabled = isOptimizelyFeatureEnabledFactory(
    EXPERIMENT_KEY_SINGLE_MENU_API,
  )

  return getIsSingleMenuApiEnabled(dispatch, getState)
}
